const renderBlock = (_: any) => {
    return (
        <div>
            <h3>Paint Block</h3>
        </div>
    );
};

export default renderBlock;
